import StyledTableCell from "@components/Table/TableCell";
import StyledTableRow from "@components/Table/TableRow";
import { TABLE_HEADER_CELL_FONT_SIZE } from "@constants/table";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { ClientModelFile } from "@services/api/types";
import { useMemo } from "react";
import { ModelFileCSVViewerColumn } from "./TableTypes";

export interface ModelFileCSVViewerProps {
  data: ClientModelFile;
}

const ModelFileCSVViewer = ({ data }: ModelFileCSVViewerProps) => {
  const columns: ModelFileCSVViewerColumn[] = useMemo(() => {
    return data.columns.map((column) => ({
      id: column,
      label: column,
      minWidth: 100,
      align: "center"
    }));
  }, [data]);

  const tableRows = useMemo(() => {
    return data.data.map((row, index) => {
      return (
        <StyledTableRow
          sx={{ "& > *": { borderBottom: "unset" } }}
          key={`${data.name}-row-${index}`}
        >
          {row.map((cell, index) => (
            <StyledTableCell key={`${data.name}-cell-${index}`}>
              {cell}
            </StyledTableCell>
          ))}
        </StyledTableRow>
      );
    });
  }, [data]);
  return (
    <Box>
      <TableContainer
        className="w-full mt-8 overflow-y-scroll"
        sx={{ maxHeight: "calc(100vh - 450px)", minHeight: 300 }}
      >
        <Table stickyHeader aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    borderRight:
                      index === columns.length - 1
                        ? "none"
                        : "1px solid #caccce",
                    fontSize: TABLE_HEADER_CELL_FONT_SIZE
                  }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{tableRows.length > 0 && tableRows}</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ModelFileCSVViewer;
